
import { SOFTWARE } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state === 'undefined') {
        state = [];
    }
    switch (action.type) {
        case SOFTWARE.PLATFORMS.INITIATE:
            return {isFetching: true};
        case SOFTWARE.PLATFORMS.SUCCESS:
            return {isFetching: false, data: action.payload};
        case SOFTWARE.PLATFORMS.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};
